<flx-heading-with-instructions [title]="title" [instructions]="instructions"></flx-heading-with-instructions>
<div class="listItems" *ngIf="listItems">
	<ul>
		<ng-container *ngFor="let item of listItems">
			<li>{{ item }}</li>
		</ng-container>
	</ul>
</div>
